import "./Representation.module.css";
import MainNavigation from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import IndustryConnections from "./sections/IndustryConnections";
import FooterArchive from "@/reusable_sections/Footer";
export default function RepresentationPage() {
  return <div>
      <MainNavigation />
      <GetInTouch />
      <IndustryConnections />
      <FooterArchive />
    </div>;
}